import React from 'react'
import dayjs from 'dayjs'
import { t } from 'i18next'
import { stripHtml } from './Common'

const displayNotification = (api, title, body, htmlBody) => {
  // eslint-disable-next-line no-new
  new Notification(title, { body })
  api.info({
    key: 'app',
    title: <b>{title}</b>,
    description: htmlBody || body,
    duration: 0
  })
}

const HtmlBodyEvent = ({ event, body, navigate }) => {
  return (<>
    <div>{body}</div>
    <div><a onClick={() => navigate(`/admin/events/${event.id}`)}>{t('Admin.notification.event.link')}</a></div>
  </>)
}

const HtmlBodyAppointment = ({ appointmentId, body, navigate }) => {
  return (<>
    <div>{body}</div>
    <div><a onClick={() => navigate(`/admin/appointments/${appointmentId}`)}>{t('Admin.notification.appointment.link')}</a></div>
  </>)
}

const HtmlBodyIntervener = ({ intervenerId, body, navigate }) => {
  return (<>
    <div>{body}</div>
    <div><a onClick={() => navigate(`/admin/interveners/${intervenerId}`)}>{t('Admin.notification.intervener.link')}</a></div>
  </>)
}

const notifyEvent = (api, navigate, event, messageType) => {
  const translateType = t(`Admin.notification.event.type.${messageType}`)
  const title = `${event.box.name} ${translateType} : ${event.title}`
  const body = stripHtml(event.content_trix_html).slice(0, 100)
  displayNotification(api, title, body, <HtmlBodyEvent event={event} body={body} navigate={navigate} />)
}

const newComment = (api, navigate, event, user) => {
  const title = `${event.box?.name} ${event.title}`
  const body = `Nouveau commentaire de ${user.first_name} ${user.last_name}`
  displayNotification(api, title, body, <HtmlBodyEvent event={event} body={body} navigate={navigate} />)
}

const updateBox = (api, box) => {
  const title = box.name
  const body = t(`Admin.Box.state.${box.state}`)
  displayNotification(api, title, body)
}

const appointment = (api, navigate, messageType, appointment, user) => {
  const title = `${appointment.box.name} : ${dayjs(appointment.begin_date).format('DD/MM H[h]mm')}-${dayjs(appointment.end_date).format('H[h]mm')}`
  const body = `${user.first_name} ${user.last_name} ${t(`Admin.notification.appointment.${messageType}`)}`
  displayNotification(api, title, body, <HtmlBodyAppointment appointmentId={appointment.id} body={body} navigate={navigate} />)
}

const message = (api, navigate, messageType, message) => {
  if (messageType === 'update_message') { return }
  const title = `${message.sender} : ${dayjs(appointment.created_at).format('DD/MM H[h]mm')}`
  const body = `${t(`Admin.notification.message.${messageType}`)} : ${message.content.slice(0, 100)}`
  const html = message.owner_type === 'Appointment' ? <HtmlBodyAppointment appointmentId={message.owner_id} body={body} navigate={navigate} /> : <HtmlBodyIntervener intervenerId={message.owner_id} body={body} navigate={navigate} />
  displayNotification(api, title, body, html)
}

export const lbmNotification = (navigate, data, api) => {
  switch (data.entity_type) {
    case 'event':
      notifyEvent(api, navigate, data.entity, data.message_type)
      break
    case 'comment':
      newComment(api, navigate, data.entity, data.user)
      break
    case 'box':
      updateBox(api, data.entity)
      break
    case 'appointment':
      appointment(api, navigate, data.message_type, data.entity, data.user)
      break
    case 'message':
      message(api, navigate, data.message_type, data.entity)
      break
    default:
      break
  }
}
